import { useState, useEffect } from 'react';
import './CookieBanner.css';

const COOKIE_KEY = 'dmyor_cookie_consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(COOKIE_KEY)) {
      // Small delay so it doesn't flash on initial paint
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie notice">
      <div className="cookie-text">
        We use cookies to keep you signed in and understand how people use dmyor.
        No tracking for ads. <a href="/cookie-policy" className="cookie-link">Cookie policy</a>
      </div>
      <button className="cookie-btn" onClick={accept}>
        Got it
      </button>
    </div>
  );
};

export default CookieBanner;
